export default __webpack_public_path__ + "static/media/bg.721c2ec9.jpg";